import { Typography } from "@mui/material";

import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { UsersTable } from "Users/Components/UsersTable";

export const UsersPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout title={t(Resources.Common.Users)}>
      <Typography variant="h1">{t(Resources.Common.Users)}</Typography>
      <UsersTable />
    </AuthenticatedLayout>
  );
};
